import React, { Component } from 'react'
import classNames from 'classnames'

import AvatarGroup from 'components/Utils/AvatarGroup'
import { TooltipOnHover } from 'components/Utils/TooltipOnHover'
import { Text } from 'components/base'

const MAX_AVATAR_NUMBER = 3

class CommentReplies extends Component {
  renderAvatarGroup = repliers => {
    return (
      <div className="flexbox flexbox-align-center">
        <AvatarGroup
          users={repliers}
          size="small"
          alignStart
          borderColor="white"
        />
        {repliers.length > MAX_AVATAR_NUMBER && (
          <TooltipOnHover
            id={'repliers-tooltip'}
            tooltipContent={`and ${repliers.length - MAX_AVATAR_NUMBER} more`}
            placement="bottom"
          >
            <div
              className={classNames(
                'background-shade-40 border-shade-50 radius-round flexbox font-size-smaller bold flexbox-centered flexbox-align-center shade-20 border-medium'
              )}
              style={{
                width: 28,
                height: 28,
                marginLeft: -6,
              }}
            >
              {repliers.length - MAX_AVATAR_NUMBER}
            </div>
          </TooltipOnHover>
        )}
      </div>
    )
  }
  render() {
    const { numberOfReplies, repliers, onReply } = this.props
    return (
      <div
        className="pointer flexbox flexbox-align-center margin-top-small"
        onClick={onReply}
      >
        <Text.Action className="margin-right-small">
          {numberOfReplies} {numberOfReplies === 1 ? 'reply' : 'replies'}
        </Text.Action>
        {this.renderAvatarGroup(repliers)}
      </div>
    )
  }
}

export default CommentReplies
